"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateBooleanMatrix = void 0;
const generateBooleanMatrix = (length, defaultValues = []) => {
    const matrix = new Array(length).fill(false);
    defaultValues.forEach((b, index) => {
        matrix[index] = b;
    });
    return matrix;
};
exports.generateBooleanMatrix = generateBooleanMatrix;
//# sourceMappingURL=generateBooleanMatrix.js.map